import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { callGet, Retrieving } from 'helpers/apiTypes';
import { prepareForBackend, toArrayOfIdObject } from 'helpers/objects';

export type IMember = API['Member']['read'];
export type IMemberCreate = API['Member']['create'];
export type IMemberUpdate = API['Member']['update'] & {
  publicationsOverwrite?: { id: number }[];
};

function prepareForUpdate(project: IMember): IMemberUpdate {
  const updated = prepareForBackend(project, ['id']) as IMemberUpdate;
  updated.publicationsOverwrite = toArrayOfIdObject(project.publications);
  return updated;
}
function prepareForCreate(project: IMember): IMemberCreate {
  return prepareForBackend(
    {
      ...project,
    },
    ['id'],
  ) as IMemberCreate;
}

export const fetchMembers = async () => {
  try {
    const query = {
      '*': true,
      image: {
        '*': true,
      },
      user: {
        id: true,
        username: true,
      },
      publications: {
        '*': true,
      },
      projects: {
        '*': true,
      },
    } as const satisfies Retrieving<'Member'>;
    const response = await callGet('Member', query);
    return response.response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const postMemberData = async (data: IMember) => {
  try {
    const response: any = await api.post('Member', prepareForCreate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchMemberData = async (data: IMember) => {
  try {
    const response = await api.patch(
      'Member/' + data.id,
      prepareForUpdate(data),
    );
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deleteMemberData = async (id: number) => {
  try {
    const response: any = await api.delete('Member/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};
